<template>
    <SimpleTable
        :flat="true"
        id="sanciones"
        title="Sanciones"
        subtitle="Infracciones y restricciones aplicadas"
        :columns="columns"
        :data="sanciones"
        empty-text="No hay sanciones registradas"
        :default-col-width="defaultColWidth"
    >
        <template #header-action>
            <Button
                @click="$emit('add-sancion')"
                class="tw:text-xs tw:sm:text-sm"
            >
                Añadir sanción
            </Button>
        </template>

        <template #cell-bloquear_acceso="{ row }">
            <span :class="row.bloquear_acceso ? 'tw:text-green-600' : 'tw:text-gray-400'">
                {{ row.bloquear_acceso ? '✓' : '✗' }}
            </span>
        </template>
        <template #cell-motivo="{ row }">
            <div v-html="row.motivo" class="tw:text-gray-600"></div>
        </template>
        <template #cell-acciones="{ row }">
            <Button
                @click="borrarSancion(row)"
                variant="danger"
                class="tw:text-xs tw:sm:text-sm"
            >
                Borrar
            </Button>
        </template>
    </SimpleTable>
</template>

<script setup>
    import Button from '@/modules/admin/ui/Button.vue'
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'

    const props = defineProps({
        sanciones: {
            type: Array,
            default: () => []
        },
        abonado: {
            type: Object,
            required: true
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    const emit = defineEmits(['actualizar', 'borrar-sancion', 'add-sancion'])
    const columns = [
        { key: 'fecha_inicio', label: 'Fecha inicio' },
        { key: 'fecha_fin', label: 'Fecha fin' },
        { key: 'bloquear_acceso', label: 'Acceso bloqueado' },
        { key: 'motivo', label: 'Motivo' },
        { key: 'acciones', label: 'Acciones' }
    ]

    const borrarSancion = row => {
        emit('borrar-sancion', { sancionId: row.id, abonado: props.abonado })
    }
</script>
